import { FC } from 'react';

interface ErrorIconProps {
  width?: string;
  height?: string;
}

export const ErrorIcon: FC<ErrorIconProps> = ({ width = 36, height = 32 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 36 32"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
    >
      <path
        opacity="0.66"
        d="M17 0C25.8366 0 33 7.16344 33 16C33 24.8366 25.8366 32 17 32C8.16344 32 1 24.8366 1 16C1 7.16344 8.16344 0 17 0ZM8.2002 10.9326L13.2666 15.999L8.2002 21.0664L11.9336 24.7998L17 19.7324L22.0664 24.7998L25.7998 21.0664L20.7334 15.999L25.7998 10.9336L22.0664 7.2002L17 12.2656L11.9336 7.19922L8.2002 10.9326Z"
        fill="url(#paint0_linear_5234_25626)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5234_25626"
          x1="39.8357"
          y1="-15.5375"
          x2="52.8112"
          y2="29.929"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E13F71" />
          <stop offset="0.929667" stopColor="#E13F71" stopOpacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  );
};
